import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../../components/ui/button'
import { Loader2 } from 'lucide-react'
import toast from 'react-hot-toast'
import { useMutation, useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import useAuth from '../../../../../hooks/useAuth'
import axios from '../../../../../lib/axios'
import { MultiSelect, Option } from '../../../../../components/ui/multi-select'
import { Label } from '../../../../../components/ui/label'
import { Combobox } from '../../../../../components/ui/combobox'
import { Input } from '../../../../../components/ui/input'
import { RadioGroup, RadioGroupItem } from '../../../../../components/ui/radio-group'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../redux'

const EditKassaPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { id } = useParams()
    const { auth } = useAuth()

    const partners = useSelector((state:RootState)=>state.partners);

    const { data:deviescurrencies } = useQuery<DeviesCurrency[] | null>({
        queryKey: ['devies-currency'],
        queryFn: async () => {
            try {
                const { data } = await axios.get('/deviescurrency/get', { params: {
                    token: auth.data?.token
                }})
                if(data.errorcode!==0){ throw new Error(data.message) }
                return data.object
            } catch (error) {
                console.log(error)
                toast.error(t('settings.fc.toast_error_fetch_foreign'), { id:'devies-currency' })
                return null
            }
        },
        refetchOnWindowFocus: false
    })

    const getCurrentKassa = useCallback(async () => {
        try {
            toast.loading(t('settings.fc.toast_loading_fetch_kassa'), { id:'kassas' })

            const { data } = await axios.get('/kassa/get', { params: {
                token: auth.data?.token,
                kassaid: id
            }})
            if(data.errorcode!==0){ throw new Error(data.message) }

            if(!Array.isArray(data.object) || (Array.isArray(data.object) && data.object.length > 1)){ throw new Error('Invalid data') }

            toast.remove('kassas')

            let result = data.object[0]

            setselected_relnr(result.relnr?.toString())
            setdescription(result.omschrijving?.toString())
            setvault(result.vault?.toString())
            setcn(result.cn?.toString().toLowerCase())

            // GET VALUTAS

            return result
        } catch (error) {
            console.log(error)
            toast.error(t('settings.fc.toast_error_fetch_kassa'), { id:'kassas' })
        }
    }, [])

    useEffect(()=>{
        if(id){ getCurrentKassa() }
    }, [id])

    const { mutate, isLoading } = useMutation({
        mutationFn: async () => {
            try {
                
            } catch (error) {
                console.log(error)
                toast.error(t('settings.fc.toast_error_edit_kassa'), { id:'kassas' })
            }
        }
    })

    const [selected_relnr, setselected_relnr] = useState<string | undefined>(undefined);
    const [selected_valuta, setselected_valuta] = useState<Option[] | undefined>(undefined);
    const [description, setdescription] = useState('');
    const [vault, setvault] = useState('');
    const [cn, setcn] = useState('c');

    function isComplete() {
        try {
            const s = z.object({
                
            })

            s.parse({
                
            })
            return true
        } catch (error) {
            return false
        }
    }

    let partnersArr = Array.isArray(partners) ? (partners.map((item) => ({value:item.relnr, label:item.name}))) : []
    const deviescurrenyOptions = Array.isArray(deviescurrencies) ? deviescurrencies.map(dc=>({value:dc.deviescurrencyid.toString(), label:dc.deviescurrencyname})) : []

  return (
    <div className="w-full p-4 overflow-auto max-h-[100dvh] min-h-[100dvh] h-full md:p-8">
        <div className='flex items-center justify-between'>
            <h1 className='text-2xl font-semibold'>{t('settings.fc.edit_kassa_title')}</h1>
            <Link to=".."><Button variant='secondary'>{t('settings.fc.back')}</Button></Link>
        </div>

        <div className='grid grid-cols-2 gap-4 p-4 mt-4 border rounded-sm md:mt-8'>
            <div>
                <Label>{t('settings.fc.partner')}</Label>
                <Combobox selectedValue={selected_relnr} onValueChange={({value})=>setselected_relnr(value.toString())} options={partnersArr} placeholder={t('settings.fc.partner_placeholder')||''} input_placeholder={t('settings.fc.partner_search')||''}/>
            </div>
            <div>
                <Label>{t('settings.fc.description')}</Label>
                <Input value={description} onChange={(e)=>setdescription(e.target.value)} />
            </div>
            <div className='flex items-end gap-8 col-span-full'>

                <div>
                    <Label>Vault</Label>
                    <Input value={vault} onChange={(e)=>setvault(e.target.value)} maxLength={3} className='w-[100px]' />
                </div>
                <RadioGroup value={cn} onValueChange={(v)=>setcn(v)}>
                    <div className='flex items-center gap-1'>
                        <RadioGroupItem value='c' id='c'/>
                        <Label htmlFor='c'>{t('settings.fc.coins')}</Label>
                    </div>

                    <div className='flex items-center gap-1'>
                        <RadioGroupItem value='n' id='n'/>
                        <Label htmlFor='n'>{t('settings.fc.notes')}</Label>
                    </div>
                </RadioGroup>
            </div>

            <div>
                <Label>{t('settings.fc.active_valutas')}</Label>
                <MultiSelect selectedValue={selected_valuta} onValueChange={(v)=>{setselected_valuta(v)}} options={deviescurrenyOptions} placeholder={t('settings.fc.valuta_placeholder')||''}/>
            </div>

            <div className='col-span-full'>
                <Button onClick={()=>{mutate()}} disabled={!isComplete() || isLoading} className='gap-2'>
                    {isLoading && <Loader2 className='w-4 h-4 animate-spin' />}
                    {t('settings.fc.save')}
                </Button>
            </div>
        </div>
    </div>
  )
}

export default EditKassaPage